import React, { useContext, useEffect, useState } from 'react'
import { handleSubmission, submission } from 'Auth'
import { BASE_URL } from 'BaseURL'
import { useNavigate } from 'react-router-dom'
import { clearInputs } from 'utils/ClearInputs'
import { themeContext } from 'contexts/theme_context/ThemeContext'
import 'pages/login/AuthShared.css'; // Shared styles

export default function ResetPassword() {
    let navto = useNavigate()
    let [loading, setLoading] = useState(false)
    let [user, setUser] = useState({})
    let [err, setErr] = useState({})
    let { webtheme } = useContext(themeContext)

    useEffect(() => {
        for (let i of Object.keys(err)) {
            let id = i + 'p'
            if (id == 'emailp') {
                if (document.getElementById(id)) document.getElementById(id).innerText = err[i]
            }
            else {
                if (document.getElementById('emailp')) document.getElementById('emailp').innerText = err[i]
            }
        }
    }, [err])

    const validation = (submission, e, obj, url, setErr, navto, router, setLoading, setAuth, createCookie) => {
        e.preventDefault()
        clearInputs(obj)
        setErr({})
        let err = {}
        // Error display logic handled by useEffect mostly, but safety check
        submission(e, obj, url, setErr, navto, router, setLoading, setAuth, createCookie)
    }

    const logoSrc = webtheme === 'light' ? '/Wordmark/Shift Wordmark Black.svg' : '/Wordmark/Shift Wordmark White.svg';
    const themeContainerClass = webtheme === 'dark' ? 'dark-theme-bg' : '';
    const themeCardClass = webtheme === 'dark' ? 'dark-theme-card' : '';

    return (
        <div className={`auth-container ${themeContainerClass}`}>
            <div className={`auth-card ${themeCardClass}`}>
                <div className="auth-header">
                    <img src={logoSrc} alt="Shift EV" className="auth-logo" />
                    <h1 className="auth-title">Reset Password</h1>
                    <p className="auth-subtitle">Request an email reset link</p>
                </div>

                <form className="auth-form" onSubmit={(e) => {
                    validation(submission, e, user, BASE_URL + 'auth/users/reset_password/', setErr, navto, 'vehicles', setLoading)
                }}>
                    <div className="auth-form-group">
                        <label htmlFor="email" className="auth-label">Email</label>
                        <input
                            type="text"
                            name="email"
                            id="email"
                            className="auth-input"
                            placeholder="Enter your email"
                            onChange={(e) => { handleSubmission(e.target, user, setUser) }}
                        />
                        <p className="auth-error" id='emailp'></p>
                    </div>

                    <button className='auth-btn' disabled={loading}>
                        {loading ? <i className="fa-solid fa-spinner fa-spin"></i> : 'Send Link'}
                    </button>

                    <div className="auth-footer">
                        <p>Back to <span className="auth-link" onClick={() => { navto('/login') }}>Login</span></p>
                    </div>
                </form>
            </div>
        </div>
    )
}
